// Tour shown to the participant when they first join a session
const userSessionTourSteps = [
  {
    id: '0',
    text: 'Check if your camera and mic are switched on',
    attachTo: {
      element: '.footer',
      on: 'top',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: 'This is the control panel. It shows where you are in the process',
    attachTo: {
      element: '.step-user-control-panel',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: 'Introduction: This is where you meet the clinician, before the consultation starts',
    attachTo: {
      element: '.step-phase-introduction',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '3',
    text: 'Consultation: You are observing or participating in the consultation',
    attachTo: {
      element: '.step-phase-consultation',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '4',
    text: 'Debrief: Meeting the clinician again after the consultation',
    attachTo: {
      element: '.step-phase-debrief',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '5',
    text: 'This is the chat tab. You can use this to communicate with the clinician or other attendees',
    attachTo: {
      element: '.step-chat-tab',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '6',
    text: 'This is the attendees tab. You can see who else is in the session',
    attachTo: {
      element: '.step-attendees-tab',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

// Tour shown to the clinician when they end a session
const clinicianSessionEndTourSteps = [
  {
    text: `You're done! Click here to close`,
    attachTo: {
      element: '.step-close-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

// Tour shown to the clinician when they first log in
const clinicianDashboardSteps = [
  {
    id: '0',
    text: 'This dashboard shows an overview of future, past, and current sessions',
    advanceOn: { selector: '.step-dashboard-overview', event: 'click' },
    attachTo: {
      element: '.step-dashboard-overview',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    advanceOn: { selector: '.step-past-sessions', event: 'click' },
    text: `This tab shows past sessions`,
    attachTo: {
      element: '.step-past-sessions',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: `Check your profile, notifications and the help section here`,
    advanceOn: { selector: '.step-profile-dropdown', event: 'click' },

    beforeShowPromise: () => {
      const overviewTab = document.querySelector('#tab-overview');
      overviewTab.click();
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 200);
      });
    },

    attachTo: {
      element: '.step-profile-dropdown',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '3',
    text: `Click here to create a new session`,
    attachTo: {
      element: '.step-create-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

const clinicianStartFirstSessionSteps = [
  {
    id: '0',
    text: `Invite additional participants? Click here before you start the session`,
    attachTo: {
      element: '.step-edit-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift-edit-session',
  },
  {
    id: '1',
    text: `Ready? Click to start the session and meet the students`,
    advanceOn: { selector: '.step-start-session', event: 'click' },
    attachTo: {
      element: '.step-start-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift-edit-session',
    url: 'dashboard',
  },
];
const clinicianEntryModalTourSteps = [
  {
    id: '0',
    text: `Step 1: read this carefully!`,
    attachTo: {
      element: '.step-session-info',
      on: 'top',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: `Step 2: click to confirm`,
    advanceOn: { selector: '.step-confirm-checkbox', event: 'click' },
    attachTo: {
      element: '.step-confirm-checkbox',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: `Step 3: start the session`,
    advanceOn: { selector: '.step-confirm-start-session', event: 'click' },
    attachTo: {
      element: '.step-confirm-start-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

// Tour shown to the clinician when they first enter a session
const clinicianSessionTourSteps = [
  {
    id: '0',
    text: 'This is the control panel. It shows where you are in the process',
    attachTo: {
      element: '.step-control-panel',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: 'Introduction: This is where you meet students before the consultation starts.',
    attachTo: {
      element: '.step-phase-introduction',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: 'Consultation: You will be examining or consulting with the patient.',
    attachTo: {
      element: '.step-phase-consultation',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '3',
    text: 'Debrief: Meeting the students again after the consultation.',
    attachTo: {
      element: '.step-phase-debrief',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '4',
    text: 'This is the chat tab. You can use this to communicate with the   attendees',
    attachTo: {
      element: '.step-chat-tab',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '5',
    text: 'This is the attendees tab. You can see who else is in the session',
    attachTo: {
      element: '.step-attendees-tab',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '6',
    text: 'Click to start the introduction and meet the students',
    advanceOn: {
      selector: '.step-start-introduction',
      event: 'click',
    },
    attachTo: {
      element: '.step-start-introduction',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

const clinicianSessionTourConsultationSteps = [
  {
    id: '0',
    text: 'Connect multiple devices or share your screen in this panel.',
    attachTo: {
      element: '.step-multi-camera',
      on: 'top',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: 'Check if your camera and mic are switched on',
    attachTo: {
      element: '.footer',
      on: 'top',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: 'Ready? Click here to start the consultation',
    advanceOn: { selector: '.step-start-consultation', event: 'click' },
    attachTo: {
      element: '.step-start-consultation',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

const sessionCreationSteps = [
  {
    id: '0',
    text: `This tab shows the overview of the session`,
    attachTo: {
      element: '.step-session-overview',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: `Use this tab to write details about the session and the clinician`,
    attachTo: {
      element: '.step-session-details',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: `This part shows all details of the session`,
    attachTo: {
      element: '.step-event-form',
      on: 'bottom',
    },
    beforeShowPromise: () => {
      const overviewTab = document.querySelector('#tab-overview');
      overviewTab.click();
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 200);
      });
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '3',
    text: `Schedule your session by choosing the date and time details`,
    attachTo: {
      element: '.step-date-time',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '4',
    text: `Upload session-related images and files`,
    attachTo: {
      element: '.step-media-resources',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '5',
    text: `Enter e-mail addresses to invite specific participants or observers`,
    attachTo: {
      element: '.step-user-invite',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '6',
    text: `Want to add or change things later? Save a draft`,
    attachTo: {
      element: '.step-save-draft',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '7',
    text: `Ready? Publish the session by clicking here!`,
    attachTo: {
      element: '.step-publish-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

const userSessionDetailsTourSteps = [
  {
    id: '0',
    text: 'Click here to join the session',
    advanceOn: { selector: '.step-student-enter-session', event: 'click' },
    attachTo: {
      element: '.step-student-enter-session',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

const userDashboardSteps = [
  {
    id: '0',
    text: 'This dashboard shows an overview of future, past, and current sessions',
    advanceOn: { selector: '.step-student-overview', event: 'click' },
    attachTo: {
      element: '.step-student-overview',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: `This tab shows sessions that are live and going`,
    advanceOn: { selector: '.step-student-live-sessions', event: 'click' },
    attachTo: {
      element: '.step-student-live-sessions',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: `This tab shows past sessions`,
    advanceOn: { selector: '.step-student-past-sessions', event: 'click' },
    attachTo: {
      element: '.step-student-past-sessions',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '3',
    text: `Check your profile, notifications and the help section here`,
    attachTo: {
      element: '.step-student-profile',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

const userInvitationTourSteps = [
  {
    id: '0',
    text: 'Click here to accept the invitation',
    attachTo: {
      element: '.step-accept-invitation',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];
const userEntryModalTourSteps = [
  {
    id: '0',
    text: 'Step 1. Read this carefully!',
    attachTo: {
      element: '.step-student-session-info',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '1',
    text: 'Step 2. Click to confirm',
    advanceOn: { selector: '.step-student-confirm', event: 'click' },
    attachTo: {
      element: '.step-student-confirm',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
  {
    id: '2',
    text: 'Step 3. Enter the session',
    advanceOn: { selector: '.step-student-confirm-enter', event: 'click' },
    attachTo: {
      element: '.step-student-confirm-enter',
      on: 'bottom',
    },
    classes: 'zoom-margin-shift',
  },
];

module.exports = {
  userSessionTourSteps,
  clinicianSessionEndTourSteps,
  clinicianDashboardSteps,
  clinicianSessionTourSteps,
  clinicianSessionTourConsultationSteps,
  sessionCreationSteps,
  userSessionDetailsTourSteps,
  userDashboardSteps,
  userInvitationTourSteps,
  userEntryModalTourSteps,
  clinicianStartFirstSessionSteps,
  clinicianEntryModalTourSteps,
};
